















































































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import CtaButton from '@/modules/shared/components/shared/kit/CtaButton.vue'
import SocialIcon from '@/modules/shared/components/shared/icon/SocialIcon.vue'
import AppMenu from '@/modules/common/layout/components/shared/menu/AppMenu'
import MenuExpandable from '@/modules/common/layout/components/shared/menu/MenuExpandable.vue'
import MenuItems from '@/modules/common/layout/components/shared/menu/MenuItems.vue'
import { Prop, Watch } from 'vue-property-decorator'
import { UserBootUseCase } from '@/modules/user/use-cases/shared/user-boot.use-case'
import { MenuStore } from '@/modules/common/layout/store/menu.store'

@Component({
  metaInfo: {
    title: 'مدیریت'
  },
  components: {
    AppMenu,
    SocialIcon,
    CtaButton,
    BaseButton,
    MenuExpandable,
    MenuItems
  }
})
export default class BaseDrawer extends Vue {
  constructor(
    private readonly userBootUseCase: UserBootUseCase,
    private readonly menuStore: MenuStore
  ) {
    super()
  }

  @Prop({ default: 'bg-nik-primary' }) background!: string
  @Prop({ default: false }) hasWhiteLogo!: boolean
  showDrawer = !this.$q.screen.lt.md

  @Watch('showDrawer')
  onShowDrawerChange(newValue) {
    if (!newValue && this.$q.screen.width > 992) {
      (this.$refs.drawer as any).__updateBelowBreakpoint()
    }
  }

  /*-----------------------computed*/
  get menu() {
    return this.menuStore.items
  }

  get miniDrawer() {
    return this.menuStore.miniDrawer
  }

  set miniDrawer(value) {
    this.menuStore.miniDrawer = value
  }

  get logo() {
    let name = (!this.miniDrawer) ? 'logo' : 'icon'
    return require('@/assets/logo/' + name + '-green.png')
  }

  // get fish() {
  //   return require('@/assets/images/nowruz/fish-bowl.png')
  // }
  //
  // //TODO: remove-start
  // get grassStyle() {
  //   return {
  //     bottom: (this.$q.screen.width < 769) ? '-8px' : '-24px' + '!important',
  //     width: (this.$q.screen.width < 769) ? '282px' : '235px' + '!important', //235
  //     height: (this.$q.screen.width < 769) ? '30px' : '40px' + '!important',
  //     position: 'absolute !important'
  //   }
  // }

  get logoBadge() {
    return (!this.miniDrawer)
      ? {
        position: 'absolute',
        width: '25px',
        height: '25px',
        top: '-13px',
        right: (this.$q.screen.width < 993) ? '44px' : '28px'
      }
      : {
        position: 'absolute',
        width: '25px',
        height: '25px',
        top: '-13px',
        right: '-2px'
      }
  }

  /*-------------------methods*/
  toggleDrawer() {
    if ((this.$refs.drawer as any).belowBreakpoint) {
      this.miniDrawer = false
      this.showDrawer = !this.showDrawer
    } else {
      this.miniDrawer = !this.miniDrawer
    }
  }

  toggleMiniDrawer() {
    if (this.menuStore.forceClose) {
      this.miniDrawer = true
      return
    }
    this.miniDrawer = !this.miniDrawer
  }

  close() {
    if (this.$q.screen.lt.md) {
      this.showDrawer = false
    }
  }

  get user() {
    return this.userBootUseCase.user
  }
}
